import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";

function MCQ({ question, options, correctOption, explanation, index }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [message, setMessage] = useState("");
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option === correctOption) {
      setMessage(explanation);
    } else {
      setMessage("Wrong answer. Try again!");
    }
  };

  return (
    <Card className="mcq-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>
          {index}. {question}
        </Card.Title>
        {options.map((option, index) => (
          <Button
            index={index}
            size="sm"
            variant="outline-dark"
            onClick={() => handleOptionClick(option)}
            style={{ margin: "5px" }}
          >
            {option}
          </Button>
        ))}
        {message && (
          <div
            style={{
              marginTop: "10px",
              color: selectedOption === correctOption ? "green" : "red",
            }}
          >
            {message}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default MCQ;
